import { fetchAuthSession } from '@aws-amplify/auth';

export const getAccessToken = async () => {
  const session = await fetchAuthSession();

  const accessToken = session.tokens?.accessToken.toString() ?? '';
  const idToken = session.tokens?.idToken?.toString() ?? '';

  return { accessToken, idToken };
};
